var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    viewBox: "0 0 62 50",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.79 44.43A35.249 35.249 0 0 0 19.82 50c23.063 0 36.084-19.428 35.303-36.857a25.157 25.157 0 0 0 6.193-6.41 24.913 24.913 0 0 1-7.134 1.95 12.425 12.425 0 0 0 5.46-6.863 24.855 24.855 0 0 1-7.878 3.01 12.455 12.455 0 0 0-14.96-2.49 12.398 12.398 0 0 0-6.246 13.79A35.292 35.292 0 0 1 4.968 3.185C1.67 8.847 3.354 16.09 8.814 19.725a12.37 12.37 0 0 1-5.631-1.548c-.072 5.96 4.113 11.128 9.967 12.31a12.364 12.364 0 0 1-5.607.207A12.407 12.407 0 0 0 19.137 39.3 24.971 24.971 0 0 1 .789 44.43z",
    fill: "#FFF",
    fillRule: "nonzero"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.724e88478fb02f3147cb2b433b1518dd.svg";
export { ForwardRef as ReactComponent };